import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row secret-data-registry" }
const _hoisted_2 = { class: "col span-12 registry-url" }


import DetailText from '@shell/components/DetailText.vue';

export interface Props {
  registryUrl?: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Registry',
  props: {
    registryUrl: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DetailText, {
        value: props.registryUrl,
        "label-key": "secret.registry.domainName"
      }, null, 8, ["value"])
    ])
  ]))
}
}

})